module.exports = __webpack_public_path__ + "europa-20_signature.jpg?fc1d1d4fdc8acec1ac930501d3d2d380";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_signature.jpg
// module id = 339
// module chunks = 0